export default {
	title: "Configuración Inicial",
	complete: "Completar",
	error: "Error al guardar. Inténtelo de nuevo.",
	requiredHint: "Los campos con * son obligatorios.",
	step1: {
		title: "Datos del Templo",
		subtitle: "Información básica de su templo",
		tradition: "Tradición Religiosa",
		zipCode: "Código Postal",
		city: "Ciudad",
		state: "Provincia",
		address: "Dirección",
		whatsapp: "WhatsApp",
		cnpj: "CNPJ",
		razaoSocial: "Razón Social",
	},
	step2: {
		title: "Sus Datos",
		subtitle: "Su perfil en el templo",
		displayName: "Nombre Completo",
		religiousName: "Nombre Religioso",
		religiousNameHint: "Ej: Pai João de Xangô",
		userTitle: "Título/Cargo",
		userTitleHint: "Ej: Babalorixá, Mãe de Santo, Dirigente",
		phone: "Teléfono",
		whatsappOptIn: "Recibir avisos del ORI por WhatsApp",
		whatsappOptInHint:
			"Enviados desde el número oficial del ORI al teléfono indicado arriba. Puede desactivarlo en cualquier momento en su perfil.",
	},
	step3: {
		title: "Personalización",
		subtitle: "Identidad visual del templo",
		optional: "Este paso es opcional. Puede configurarlo después.",
		logoUrl: "URL del Logo",
		primaryColor: "Color Principal",
	},
	step4: {
		title: "Plan",
		subtitle: "Confirma tu plan",
		hint: "Revisa el plan elegido, aplica un cupón si tienes uno y finaliza la suscripción.",
		confirmAndPay: "Confirmar y pagar",
		decideLater: "Decidir después",
	},
};
